// @flow

// Polyfill
import 'whatwg-fetch'

// Effect Managers
import { cancel, fork, put, take } from 'redux-saga/effects'

// Sagas
import auth from 'hfty-auth/src/sagas/main'
import users from 'fc-users/sagas'
import assets from 'hfty-assets/src/sagas/main'
import soilJobs from 'hfty-soil-jobs/src/sagas/main'
import comments from 'hfty-comments/src/sagas/main'
import accounts from 'hfty-accounts/src/sagas/main'
import userSaga from 'hfty-users-dom/src/sagas/main'
import requestResetPassword from 'hfty-auth/src/sagas/requestReset'
import resetPassword from 'hfty-auth/src/sagas/resetPassword'
import { mainSaga as assetsModule } from 'hfty-assets-dom'
import { mainSaga as soilJobsModule } from 'hfty-soil-jobs-dom'
import { main as samplingPointModule } from 'hfty-sampling-point'
import { mainSaga as commentsModule } from 'hfty-comments-dom'
import { start as startSeasons } from 'fc-seasons'
import mapSaga from 'hfty-map/src/sagas/main'
import mapDomSaga from 'hfty-map-dom/src/sagas/main'
import { start as startEnvironment } from 'fc-environment'
import { mainSaga as contactUsModule } from 'hfty-contact-us'
import { mainSaga as ordersModule } from 'hfty-orders'
import { mainSaga as heftySeasonsModule } from 'hfty-seasons'
import { mainSaga as heftySuppliesModule } from 'hfty-supplies'
import { mainSaga as heftyReportsModule } from 'hfty-reports-dom'
import { mainSaga as heftyAssetMigrateModule } from 'hfty-asset-migrate-dom'
import { gridSaga } from 'hfty-grid'
import { mainSaga as recommendationsSaga } from 'hfty-recommendations'
import { start as soilTestResults } from 'fc-soil-test-results'
import { mainSaga as fertilizerModule } from 'hfty-fertilizers'
import { mainSaga as orderTestsModule } from 'hfty-order-tests-dom'

// Actions
import {
  RECEIVE_TOKEN,
  REMOVE_CREDENTIALS,
} from 'fc-auth'

import {
  RESET_STORE,
} from 'fc-utils/createReducer'

// Exports
export function resetStore (payload: Object): Object {
  return {
    type: RESET_STORE,
    payload,
  }
}

export default function *hefty (): Generator<*, *, *> {
  let task

  while (true) {
    yield fork(users)
    task = yield fork(initialize)
    yield fork(auth)

    while (true) {
      yield take(REMOVE_CREDENTIALS)
      const resetStoreAction = yield resetStore({})
      yield put(resetStoreAction)

      if (task) {
        yield cancel(task)
      }

      task = yield fork(initialize)
    }
  }
}

export function *initialize (): Generator<*, *, *> {
  const accountTask = yield fork(accounts)
  const reqestResetTask = yield fork(requestResetPassword)
  const resetPasswordTask = yield fork(resetPassword)
  yield take(RECEIVE_TOKEN)
  yield cancel(accountTask)
  yield cancel(reqestResetTask)
  yield cancel(resetPasswordTask)
  yield fork(startEnvironment)
  yield fork(startSeasons)
  yield fork(assets)
  yield fork(assetsModule)
  yield fork(heftyAssetMigrateModule)
  yield fork(soilJobs)
  yield fork(soilJobsModule)
  yield fork(comments)
  yield fork(commentsModule)
  yield fork(heftySeasonsModule)
  yield fork(mapSaga)
  yield fork(mapDomSaga)
  yield fork(heftyReportsModule)
  yield fork(userSaga)
  yield fork(contactUsModule)
  yield fork(ordersModule)
  yield fork(gridSaga)
  yield fork(recommendationsSaga)
  yield fork(heftySuppliesModule)
  yield fork(soilTestResults)
  yield fork(fertilizerModule)
  yield fork(orderTestsModule)
  yield fork(samplingPointModule)
}
